var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10C13.25 10.81 13.215 11.57 13.16 12.295H6.845C6.785 11.57 6.75501 10.805 6.75501 10C6.75501 9.195 6.79 8.43 6.845 7.705H13.16C13.22 8.43 13.25 9.195 13.25 10ZM10 20C11.05 20 12.415 17.72 12.98 13.825H7.015C7.585 17.72 8.95 20 9.995 20H10ZM10 0C8.95 0 7.585 2.28 7.02 6.175H12.985C12.415 2.28 11.05 0 10.005 0H10ZM14.655 7.705C14.715 8.465 14.75 9.235 14.75 10C14.75 10.765 14.72 11.535 14.655 12.295H19.735C19.9 11.555 20 10.79 20 10C20 9.21 19.905 8.445 19.735 7.705H14.655ZM14.49 6.175H19.265C18.095 3.225 15.61 0.970002 12.555 0.150002C13.505 1.575 14.155 3.765 14.49 6.175ZM5.50999 13.825H0.735001C1.905 16.775 4.39001 19.03 7.44501 19.85C6.49501 18.425 5.84499 16.235 5.50999 13.825ZM14.49 13.825C14.155 16.235 13.505 18.43 12.555 19.85C15.615 19.025 18.095 16.77 19.265 13.825H14.49ZM5.50999 6.175C5.84499 3.765 6.49501 1.57 7.44501 0.150002C4.38501 0.975002 1.905 3.23 0.735001 6.175H5.50999ZM5.345 12.295C5.285 11.535 5.25 10.765 5.25 10C5.25 9.235 5.28 8.465 5.345 7.705H0.264999C0.0999994 8.445 0 9.21 0 10C0 10.79 0.0949994 11.555 0.264999 12.295H5.345Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.6f20a379cbca888646c9bd9f39372275.svg";
export { ForwardRef as ReactComponent };